import React, { useState, useRef } from 'react'
import { motion, useInView } from 'framer-motion'

import { Container } from '../../Container'
import ContentfulLongText from '../../ContentfulLongText'

import './product-parts.css'

export const ProductParts = ({ parts }) => {
    const ref = useRef(null);
    const isInView = useInView(ref, { once: false });

    const [hoveredDotImage, setHoveredDotImage] = useState(null);

    const handleHover = (dotItem) => {
        setHoveredDotImage(dotItem);
    };

    if(parts !== null) {
        return (
            <div ref={ref} className='product-parts'>
                <Container> 
                    <div className='text-center head'>
                        <motion.img src={'https://images.ctfassets.net/vhts96p7twn6/ngyTgzrsISNNz8KkeHT4m/761956a4519cde0598fba9da2cf27a02/compostplus-logo.png'} alt="Compost+" style={{
                            transform: isInView ? "none" : "translateX(-200px)",
                            opacity: isInView ? 1 : 0,
                            transition: "all 0.9s cubic-bezier(0.17, 0.55, 0.55, 1) 0.5s"
                        }}/>
                        <motion.p className='mt-0 mb-0' style={{
                            transform: isInView ? "none" : "translateX(200px)",
                            opacity: isInView ? 1 : 0,
                            transition: "all 0.9s cubic-bezier(0.17, 0.55, 0.55, 1) 0.5s"
                        }}>Achieving both aesthetics and functionality is paramount.<br/>With Compost+, you don't have to compromise one for the other. </motion.p>
                    </div>
                    <div className='relative'>
                        <div className='center-image' style={{
                            opacity: isInView ? 1 : 0,
                            transition: "all 0.9s cubic-bezier(0.17, 0.55, 0.55, 1) 0.5s"
                        }}>
                            <img src={'https://images.ctfassets.net/vhts96p7twn6/1lV1a2uJBFPmOqWzduXZji/88d0ab9c9a4906f9584ce732785cdeef/Pono_Compost_Blue_V4_.png'} alt="Pono Compost Blue" />
                        </div>
                        <motion.div className='lists'>
                            {parts.map((item, index) => (
                                <motion.div 
                                    key={index} 
                                    style={{
                                        opacity: isInView ? 1 : 0,
                                        transition: `all ${isInView ? 0.9 * index : 0}s cubic-bezier(0.17, 0.55, 0.55, 1) ${isInView ? 0.9 * index : 0}s`
                                    }}
                                    className='absolute item'
                                    onMouseEnter={() => handleHover(index)}
                                    onMouseLeave={() => handleHover(null)}
                                    role="button" 
                                    tabIndex={0} 
                                    onClick={() => {}}
                                    onKeyDown={(event) => {
                                        if (event.key === 'Enter' || event.key === ' ') {
                                        }
                                    }}
                                >
                                    <div className={`thumbnail-image ${(item.thumbnailImage !== null) ? (hoveredDotImage === index ? 'active-dot':'has-dot') :''}`}>
                                        {item.thumbnailImage !== null && <div style={{
                                            backgroundImage: `url(${item.thumbnailImage.gatsbyImageData.images.fallback.src})`,
                                            backgroundRepeat: 'no-repeat',
                                            backgroundSize: 'cover',
                                            width: '55px',
                                            height: '55px'
                                        }} className={`dotImg dotImg${index}`}><div className={`anim--pulsate ${hoveredDotImage === index &&  'd-none'}`}></div></div>}
                                        <span className={item.thumbnailImage === null ? 'line-non-img':''}></span>
                                    </div>
                                    <div className='content'>
                                        <h6 className='mt-0 mb-0'>{item.title}</h6>
                                        <ContentfulLongText longTextContent={item.info.info} classNameProp={index >= 2 ? 'text-right' : 'text-left'} />
                                    </div>
                                </motion.div>
                            ))}
                        </motion.div>
                    </div>
                </Container>
            </div>
        )
    } else return null
}